'use strict'
import { request } from '../../plugins/http'

// export default async (companyId, situationId) => {
export default async (data) => {
    return await request.get('/atendimento',{params:data})
}